export const environment = {
    production: true,
    apiEndpoint: 'https://api.bitc-geotab.vehicle-health.bosch.tech/',
    appEndpoint: 'https://bitc-geotab.vehicle-health.bosch.tech/',
    appId: 'bitc'
};
